import styled from 'styled-components'

const TaskPopoverTitle = styled.div`
    box-sizing: border-box;
    color: #5e6c84;
    display: block;
    line-height: 40px;
    border-bottom: 1px solid rgba(9,30,66,.13);
    margin: 0 12px;
    padding: 0 32px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    z-index: 1;
`

export default TaskPopoverTitle